import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5fc99eaf&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc99eaf')) {
      api.createRecord('5fc99eaf', component.options)
    } else {
      api.reload('5fc99eaf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5fc99eaf&", function () {
      api.rerender('5fc99eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role/index.vue"
export default component.exports